<div #baseThreeJscontent class="w-100 h-100"></div>